import { Dispatch } from "redux";
import { createAddDocumentsAction, DocIdToDocument } from "../../..";
import { constructDocumentDataFromDto, Document, UserReadConfirmItems } from "../../../../..";

interface DocumentResponse {
    key: string,
    value: Document
}
export const processFetchReadConfirmResponse = (dispatch: Dispatch) => (results: DocumentResponse[]): UserReadConfirmItems => {   
    const docIdToDocument: DocIdToDocument = {}
    results.forEach(x => {
        const document = constructDocumentDataFromDto({Key: x.key, Value: {Source: x.value, Key: x.key}})

        docIdToDocument[x.key] = {
            document,
            isUpdating: false,
            isDeleting: false,
            isFetching: false
        }
    })
    dispatch(createAddDocumentsAction(docIdToDocument))

    return results.map(result => result.key)
}